import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ShieldCheck, ArrowUpCircle } from 'lucide-react';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900" data-id="element-87">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-88">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-89">
          <div className="flex items-center gap-3" data-id="element-90">
            <div className="w-8 h-8 md:w-10 md:h-10 bg-teal-900 rounded-lg flex items-center justify-center text-teal-400 font-bold text-lg md:text-xl" data-id="element-91">
              🩺
            </div>
            <div data-id="element-92">
              <h4 className="text-white font-bold text-base md:text-lg leading-tight" data-id="element-93">
                MEGAPACK DE GESTIÓN
              </h4>
              <p className="text-[10px] md:text-xs text-teal-500" data-id="element-94">
                PARA CONSULTORIO ONCOLÓGICO™
              </p>
            </div>
          </div>

          <button onClick={scrollToTop} className="flex items-center gap-2 text-xs md:text-sm hover:text-white transition-colors" data-id="element-95">
            Volver arriba <ArrowUpCircle className="h-3 w-3 md:h-4 md:w-4" data-id="element-96" />
          </button>
        </div>

        <div className="border-t border-slate-800 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs md:text-sm text-center md:text-left" data-id="element-97">
          <p className="max-w-2xl" data-id="element-98">
            El sistema de gestión para oncólogos independientes en Argentina.
            Porque gestionar tu consultorio no debería robarte el tiempo que
            necesitás para tus pacientes.
          </p>
        </div>

        <div className="mt-6 md:mt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] md:text-xs text-slate-500" data-id="element-99">
          <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-100">
            <span className="hover:text-slate-300 transition-colors cursor-pointer" data-id="element-101">
              contacto@solucionesya.shop
            </span>
            <span className="hover:text-slate-300 transition-colors cursor-pointer" data-id="element-102">
              @solucionesya.shop
            </span>
            <span className="hover:text-slate-300 transition-colors cursor-pointer" data-id="element-103">
              solucionesya.shop
            </span>
          </div>
          <p data-id="element-104">© solucionesya.shop™ 2026 — Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}